class BettyRedirectNavigatorImpl {
	prepare(): Promise<any> {
		return Promise.resolve(this);
	}

	isIdamLoginPathname(pathname: string): boolean {
		return (
			pathname.startsWith("/shop/login") ||
			pathname.startsWith("/backend/login") ||
			pathname.startsWith("/shop/idamLogin") ||
			pathname.startsWith("/backend/idamLogin")
		);
	}

	navigate(params: { url: string }): Promise<any> {
		if (!params || !params.url) {
			console.error("RedirectNavigator.navigate: No url provided");
			return Promise.reject(new Error("No url provided"));
		}

		// When pressing the back button on the Idam login page, we don't want to
		// be back on the login page, since that would mean that we are automatically
		// redirected back to Idam.
		if (this.isIdamLoginPathname(window.location.pathname)) {
			window.location.replace(params.url);
		} else {
			window.location.assign(params.url);
		}

		return Promise.resolve();
	}

	get url(): string {
		return window.location.href;
	}
}

export const BettyRedirectNavigator = new BettyRedirectNavigatorImpl() as BettyRedirectNavigatorImpl;
